export const AbbTextSvg = () => (
  <svg
    width="52"
    height="20"
    viewBox="0 0 52 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M28.3477 19.9997H29.5542C33.1737 19.8179 35.7073 16.9695 35.7073 13.5756C35.7073 12.4241 35.466 11.2726 34.9231 10.3635H28.3477V19.9997Z"
      fill="#FF0011"
    />
    <path
      d="M27.7513 10.3029H21.7188V19.9998H27.7513V10.3029Z"
      fill="#FF0011"
    />
    <path
      d="M34.5612 9.69704C33.9579 8.84857 33.1134 8.18191 32.2085 7.69707C33.2943 6.9092 34.0182 5.63649 34.0182 4.24258C34.0182 1.87897 32.1482 0.000213623 29.7955 0.000213623H28.3477V9.69704H34.5612Z"
      fill="#FF0011"
    />
    <path
      d="M27.7513 0.000213623H21.7188V9.69704H27.7513V0.000213623Z"
      fill="#FF0011"
    />
    <path
      d="M44.6406 19.9997H45.8471C49.4667 19.8179 52.0003 16.9695 52.0003 13.5756C52.0003 12.4241 51.759 11.2726 51.2161 10.3635H44.6406V19.9997Z"
      fill="#FF0011"
    />
    <path
      d="M44.0364 10.3029H38.0039V19.9998H44.0364V10.3029Z"
      fill="#FF0011"
    />
    <path
      d="M50.8541 9.69704C50.2509 8.84857 49.4063 8.18191 48.5014 7.69707C49.5873 6.9092 50.3112 5.63649 50.3112 4.24258C50.3112 1.87897 48.4411 0.000213623 46.0884 0.000213623H44.6406V9.69704H50.8541Z"
      fill="#FF0011"
    />
    <path
      d="M44.0364 0.000213623H38.0039V9.69704H44.0364V0.000213623Z"
      fill="#FF0011"
    />
    <path
      d="M3.43854 10.3029L0 19.9998H5.007L6.45481 15.7574H9.65205V10.3029H3.43854Z"
      fill="#FF0011"
    />
    <path
      d="M9.64972 0.000213623H7.05573L3.61719 9.69704H9.64972V0.000213623Z"
      fill="#FF0011"
    />
    <path
      d="M10.2539 15.7574H13.4511L14.899 19.9998H19.906L16.4674 10.3029H10.2539V15.7574Z"
      fill="#FF0011"
    />
    <path
      d="M16.2864 9.69704L12.8479 0.000213623H10.2539V9.69704H16.2864Z"
      fill="#FF0011"
    />
  </svg>
);
